/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { NO_OPENER_REFERRER } from 'constants';

import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'carbon-addons-iot-react';

import styles from './Footer.module.css';

const propTypes = {
  feedbackLink: PropTypes.string.isRequired,
  leftPart: PropTypes.string.isRequired,
  rightPart: PropTypes.string.isRequired,
};

const Footer = ({ feedbackLink, leftPart, rightPart }) => (
  <footer className={styles.container}>
    <div className={styles.leftPart}>{leftPart}</div>
    <div>
      <Button
        className={styles.feedback}
        target="_blank"
        rel={NO_OPENER_REFERRER}
        href={feedbackLink}>
        {rightPart}
      </Button>
    </div>
  </footer>
);

Footer.propTypes = propTypes;

export default Footer;
